import companiesCollection from "./companies";
import companyMembersCollection from "./company_members";
import companyInvitationsCollection from "./company_invitations";
import companyLeadsCollection from "./company_leads";
import companyClaimsCollection from "./company_claims";
import companyProspectsCollection from "./company_prospects";
import prospectContactsCollection from "./prospect_contacts";
import prospectActivityCollection from "./prospect_activity";
import emailThreadsCollection from "./email_threads";
import emailMessagesCollection from "./email_messages";
import emailSenderRulesCollection from "./email_sender_rules";
import emailTemplatesCollection from "./email_templates";
import notesCollection from "./notes";
import talentsCollection from "./talents";
import digestSubscriptionsCollection from "./digest_subscriptions";
import digestSendsCollection from "./digest_sends";
import jobsCollection from "./jobs";
import jobTrafficCollection from "./job_traffic";
import linkedinPostsCollection from "./linkedin_posts";
import jobNoticesCollection from "./job_notices";
import contactMessagesCollection from "./contact_messages";
import leadMagnetSignupsCollection from "./lead_magnet_signups";
import talentApplicationsCollection from "./talent_applications";
import presentedCandidatesCollection from "./presented_candidates";
import profileViewsCollection from "./profile_views";
import scrapedJobsCollection from "./scraped_jobs";
import usersCollection from "./users";

export const collections = [
    companiesCollection,
    companyMembersCollection,
    companyInvitationsCollection,
    companyLeadsCollection,
    companyClaimsCollection,
    companyProspectsCollection,
    prospectContactsCollection,
    prospectActivityCollection,
    emailThreadsCollection,
    emailMessagesCollection,
    emailSenderRulesCollection,
    emailTemplatesCollection,
    notesCollection,
    talentsCollection,
    digestSubscriptionsCollection,
    digestSendsCollection,
    jobsCollection,
    jobTrafficCollection,
    linkedinPostsCollection,
    jobNoticesCollection,
    contactMessagesCollection,
    leadMagnetSignupsCollection,
    talentApplicationsCollection,
    presentedCandidatesCollection,
    profileViewsCollection,
    scrapedJobsCollection,
    usersCollection
];
